import { cloneDeep } from './object';

const FILL_ALPHABETS = {
  pt: {
    base: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    accented: 'ÁÉÍÓÚÂÊÔÃÕÇ',
  },
  es: {
    base: 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ',
    accented: 'AEIOU',
  },
  en: {
    base: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    accented: '',
  },
};

export function addNewCell(table, row, column, CELL) {
  table.push({
    ...cloneDeep(CELL),
    positionx: row.toString(),
    positiony: column.toString(),
    text: '',
  });
}

export function isCellCompatible(index, letter, table) {
  const currentChar = table[index].text;
  return currentChar === '' || currentChar === letter;
}

export function fillRandomLetters(table, lang = 'pt') {
  const { base, accented } = FILL_ALPHABETS[lang];
  const accentChance = 0.1;

  return table.map(cell => {
    if (cell.text !== '') return cell;

    const useAccent = accented && Math.random() < accentChance;
    const letters = useAccent ? accented : base;

    const randomIndex = Math.floor(Math.random() * letters.length);
    return { ...cell, text: letters[randomIndex] };
  });
}
